import {DomainObject} from 'shared/store';
import {action, computed, observable} from 'mobx';
import {calendarDate, fullName} from 'shared/tools';
import InterviewSchedule from 'main/stores/interview_schedules/InterviewSchedule';

class InterviewInvite extends DomainObject {
  @observable startDate;
  @observable endDate;
  @observable interviewSchedule;
  @observable candidate;
  @observable booked;

  @action merge(other) {
    super.merge(other, {
      _dates: ['startDate', 'endDate'],
      interviewSchedule: InterviewSchedule
    });
  }

  @computed get scheduleName() {
    return this.interviewSchedule && this.interviewSchedule.templateName;
  }

  @computed get interviewerNames() {
    const interviewers = (this.interviewSchedule && this.interviewSchedule.interviewers) || [];
    return interviewers.map(fullName).join(', ');
  }

  @computed get formattedStartDate() {
    return calendarDate(this.startDate);
  }

  @computed get formattedEndDate() {
    return calendarDate(this.endDate);
  }
}

export default InterviewInvite;
